<template>
    <div class="objective-config-card">
        <div class="objective-header-row">
            <input-search class="objective-action-search" @getData="getSearch" />
            <div class="objective-actions-row">
                <div class="position-relative d-inline-flex">
                    <select
                        v-model="selectedGoal"
                        class="btn btn-sm bg-white fw-400 select-like-btn"
                        @change="onGoalChange"
                        style="padding:0 44px;min-width:180px;text-align:center;color:black!important;border:1px solid black!important"
                    >
                        <option value="">Todos</option>
                        <option value="ventas">Ventas</option>
                        <option :value="isMarkup ? 'markup' : 'margen'">{{ isMarkup ? 'Markup' : 'Margen' }}</option>
                        <option value="stock">Stock</option>
                        <option value="competidor">Competidores</option>
                    </select>
                    <img src="/icons/filter-recomendation.svg" alt="filter" class="icons-dark" style="position:absolute;left:10px;top:50%;transform:translateY(-50%);pointer-events:none" />
                </div>
                <button 
                    class="btn btn-sm bg-white fw-400"
                    style="
                        color: black !important;  
                        border: 1px solid black !important
                    "
                    @click="viewConfig('','config-objective-options','Configuración','Establece el objetivo de optimización para varios productos de manera simultánea')"
                >
                    Configuración en lote
                </button>
                <button 
                    class="btn fw-500 button-export text-white rounder-8 button-products d-flex align-items-center"
                    @click="exportDataFile"
                >
                    <img src="/icons/down.svg" alt="icono" class="me-1 icons">Exportar
                </button>
            </div>
        </div>

        <div class="objective-table-info-row">
            <span 
                class="objective-total-count"
                v-if="totalCount > 0 && !loading"
            >
                Total: {{ totalCount }}
            </span>
        </div>
        <div class="table-responsive border" v-if="products.length > 0 || loading">
            <placeholder v-if="loading" :type="'table'" :count="3"/>
            <table class="objective-table w-100" v-else>
                <thead>
                    <tr>
                        <th v-if="isColumnVisible('sku')">{{ getColumnLabel('sku') }}</th>
                        <th v-if="isColumnVisible('long_name')">{{ getColumnLabel('long_name') }}</th>
                        <th
                            v-if="isColumnVisible('store_name')"
                        >
                            {{ getColumnLabel('store_name') }}
                        </th>
                        <th v-if="isColumnVisible('goal')" class="editable-header">{{ getColumnLabel('goal') }}</th>
                        <th v-if="isColumnVisible('sensibility')">{{ getColumnLabel('sensibility') }}</th>
                        <th v-if="isColumnVisible('actions')">{{ getColumnLabel('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(product, index) in products" :key="index"
                    >
                        <td v-if="isColumnVisible('sku')">
                            <span class="objective-sku-badge">{{ product.sku }}</span>
                        </td>
                        <td v-if="isColumnVisible('long_name')">{{ product.long_name }}</td>
                        <td
                            v-if="isColumnVisible('store_name')"
                        >
                            {{ product.store_name }}
                        </td>
                        <td v-if="isColumnVisible('goal')" class="col-highlight">
                            <span 
                                :class="[
                                    'objective-goal-badge',
                                    getGoalBadgeClass(product.goal)
                                ]"
                            >
                                <img 
                                    :src="getGoalIcon(product.goal)" 
                                    alt="icon" 
                                    class="objective-goal-icon"
                                />
                                {{ getGoalLabel(product.goal) }}
                            </span>
                        </td>
                        <td v-if="isColumnVisible('sensibility')" v-html="$sanitize(calcItem(product.sensibility))">
                        </td>
                        <td v-if="isColumnVisible('actions')">
                            <div class="d-flex flex-column gap-1">
                                <span
                                    @click="viewConfig(product,'config-objective-one','Objetivo de optimización','Selecciona el objetivo de optimización para el producto seleccionado')"
                                >
                                    <img class="cursor-pointer" src="/icons/pencil-margin.svg" alt="Editar"/>
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- No data message -->
        <div v-if="products.length <= 0 && !loading" class="p-4 bg-white rounder-8 border border-1 text-center">
            <h4 class="fw-400 size-18 text-secondary">No existe información para mostrar</h4>
        </div>

        <PaginationControls
            v-if="totalCount > 0"
            :current-page="currentPage"
            :total-count="totalCount"
            :page-size="pageSize"
            @change-page="$emit('change-page', $event)"
            @change-page-size="$emit('change-page-size', $event)"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import inputSearch from '@/components/inputSearch.vue';
import Placeholder from "../../../../../components/loadings/placeholder.vue";
import PaginationControls from "../../../../../components/PaginationControls.vue";
import { shouldShowAsRecommender } from '../../../../../utils/servicesValidation.js'
import configsRecTableMixin from '../mixins/configsRecTableMixin.js'

export default {
    name: 'table-objective-config',
    mixins: [configsRecTableMixin],
    components: {
        inputSearch,
        Placeholder,
        PaginationControls
    },
    props: {
        products: {
            type: Array,
            required: true,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        totalCount: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 25
        }
    },
    data() {
        return {
            search_product: '',
            search_type: 'codigo',
            selectedGoal: "",
            tableConfigKey: 'objective'
        }
    },
    computed: {
        ...mapGetters([
            "authentication_user",
            "activeDesk"
        ]),
        isMarkup() {
            const result = shouldShowAsRecommender(this.authentication_user);
            return !result.serviceTypeRecommender && !result.neitherService;
        },
        tableWrapperClass() {
            return {
                'table-wrapper-fixed': true,
                'table-wrapper-expanded': !this.activeDesk,
                'table-wrapper-with-sidebar': this.activeDesk
            }
        }
    },
    methods: {
        ...mapActions(["executeCommit", "get"]),
        getSearch(row) {
            this.search_product = row.search
            this.search_type = row.searchType
            this.$emit('getData', 
                this.search_product,
                this.search_type
            )
        },
        onGoalChange() {
            this.$emit('filterGoal', this.selectedGoal);
        },
        getGoalBadgeClass(goal) {
            const classes = {
                'ventas': 'objective-goal-ventas',
                'margen': 'objective-goal-margen',
                'markup': 'objective-goal-markup',
                'stock': 'objective-goal-stock',
                'competidor': 'objective-goal-competidor',
            };
            return classes[goal] || 'objective-goal-none';
        },
        getGoalIcon(goal) {
            const icons = {
                'ventas': '/icons/lightning-recomendation.svg',
                'margen': '/icons/chartLine-recomendation.svg',
                'markup': '/icons/chartLine-recomendation.svg',
                'stock': '/icons/package-recomendation.svg',
                'competidor': '/icons/storefront-recomendation.svg',
            };
            return icons[goal] || '/icons/alert-select.svg';
        },
        getGoalLabel(goal) {
            if (!goal || goal === 'ninguno') return 'No Definido';
            if (goal === 'ventas') return 'Ventas';
            if (goal === 'margen') return 'Margen';
            if (goal === 'markup') return 'Markup';
            if (goal === 'stock') return 'Stock';
            if (goal === 'competidor') return 'Competidores';
            return goal;
        },
        viewConfig(row, name, title, text) {
            this.$emit('viewModal', row, name, title, text);
        },
        exportDataFile() {
            this.executeCommit({ mutation: "loading_state_component" });
            let url = `/api/products/export_config_objective/`;
            if (!this.authentication_user.client_channel) {
                url = url + `?business=${this.authentication_user.client_business_select}`
            }
            this.get({
                url: url,
            }).then(() => {
                this.executeCommit({ mutation: "loading_state_component" });
                this.$notification.success(
                    "En un momento te llegará un correo electrónico con los datos del objetivo de optimización",
                    { timer: 10, showCloseIcn: true }
                );
            });
        },
        calcItem(row) {
            const value = typeof row === 'string' ? row : row?.sensibilidad;
            const normalizedValue = value?.toLowerCase()?.trim();

            if (value != null && normalizedValue !== '') {
                switch (normalizedValue) {
                    case "none":
                        return `<span class='fw-600 size-12 badge rounded-pill bg-secondary custom-badge-secondary'>Datos insuficientes</span>`
                    case "muy elástico":
                    case "muy sensible":
                        return `<span class='fw-600 size-12 badge rounded-pill bg-danger custom-badge-danger'>Muy elástico</span>`;
                    case "elástico":
                    case "sensible":
                        return `<span class='fw-600 size-12 badge rounded-pill bg-warning custom-badge-warning'>Elástico</span>`;
                    case "poco sensible":
                    case "poco elástico":
                        return `<span class='fw-600 size-12 badge rounded-pill bg-success custom-badge-success'>Poco elástico</span>`;
                    case "datos insuficientes y p-value alto":
                        return `<span class='fw-600 size-12 badge rounded-pill bg-secondary custom-badge-secondary'>Datos insuficientes y p-value alto</span>`;
                    case "datos insuficientes":
                        return `<span class='fw-600 size-12 badge rounded-pill bg-secondary custom-badge-secondary'>Datos insuficientes</span>`
                    case "inelástico":
                        return `<span class='fw-600 size-12 badge rounded-pill bg-secondary custom-badge-secondary'>Inelástico</span>`;
                    case "anómalo":
                        return `<span class='fw-600 size-12 badge rounded-pill bg-secondary custom-badge-secondary'>Anómalo</span>`;
                    case "anómalo (sube precio, sube venta)":
                        return `<span class='fw-600 size-12 badge rounded-pill bg-secondary custom-badge-secondary'>Anómalo</span>`;
                    default:
                        return `<span class='fw-600 size-12 badge rounded-pill bg-secondary custom-badge-secondary'>${value}</span>`;
                    }
            } else {
                return `<span class='fw-600 size-12 badge rounded-pill bg-secondary custom-badge-secondary'>Datos insuficientes</span>`
            }
        },
    }
}
</script>

<style scoped>
.objective-config-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.objective-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 1.25rem;
}

.objective-actions-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    flex-wrap: wrap;
    flex: 0 1 auto;
    max-width: 100%;
}

.objective-actions-row .btn {
    height: 44.8px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
}

.objective-actions-row select {
    height: 44.8px;
}

.objective-actions-row select:hover {
    background-color: #f8f9fa !important;
    color: #212529 !important;
}

select.select-like-btn::-ms-expand { display: none; }

.objective-table-info-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0.5rem;
    margin-top: 0.25rem;
}

.objective-total-count {
    font-size: 0.85rem;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
}

.objective-action-search {
    flex: 1 1 250px;
    min-width: 0;
}

.objective-action-search :deep(.search-container-wrapper),
.objective-action-search ::v-deep .search-container-wrapper {
    width: 100%;
    max-width: none;
}

@media (max-width: 991.98px) {
    .objective-actions-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;
        width: 100%;
        align-items: stretch;
    }

    .objective-actions-row > * {
        box-sizing: border-box;
        min-width: 0;
        width: 100%;
    }
}

.objective-table {
    border-collapse: collapse;
    font-size: 0.85rem;
}

.objective-table thead th {
    text-align: left;
    font-size: 0.7rem;
    font-weight: 700;
    color: #9ca3af;
    letter-spacing: 0.03em;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    background-color: #F3F4F6;
}

.objective-table tbody td {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
    color: #1f2937;
}

.objective-table tbody tr:hover {
    background: #fafafa;
}

.objective-table thead th.editable-header {
    background-color: #E8F8F4;
    color: #087F6A;
    font-weight: 700;
}

.objective-table tbody td.col-highlight {
    background-color: #F8FCFB;
}

.objective-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #374151;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
}

.objective-goal-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 600;
    border: 1px solid transparent;
}

.objective-goal-icon {
    width: 16px;
    height: 16px;
}

.objective-goal-ventas {
    background: #E3F2FD;
    color: #1565C0;
    text-transform: capitalize;
}

.objective-goal-margen {
    background: #F0E5FF;
    color: #6B21A8;
    text-transform: capitalize;
}

.objective-goal-markup {
    background: #F0E5FF;
    color: #6B21A8;
    text-transform: capitalize;
}

.objective-goal-stock {
    background: #FFF3CD;
    color: #CC9A06;
    text-transform: capitalize;
}

.objective-goal-competidor {
    background: #FDE2E4;
    color: #B91C1C;
    text-transform: capitalize;
}

.objective-goal-none {
    background: #E9ECEF;
    color: #6C757D;
    text-transform: capitalize;
}

.button-export {
    background-color: #021418;
}

.button-products {
    padding: 10.5px 20px !important;
}

.icons {
    filter: brightness(0) invert(1);
    width: 20px;
    height: 20px;
}

.icons-dark {
    filter: brightness(0);
    width: 18px;
    height: 18px;
}

/*----------class badge vhtml-----------*/
::v-deep(.custom-badge-danger){
    background-color: #F8D7DA !important;
    color: #DC3545 !important;
}
::v-deep(.custom-badge-warning){
    background-color: #FFF3CD!important;
    color: #CC9A06!important;
}
::v-deep(.custom-badge-success){
    background-color: #D2F4EA!important;
    color: #1AA179!important;
}
::v-deep(.custom-badge-secondary){
    background-color: #E9ECEF!important;
    color: #6C757D!important;
}
</style>
